/**
 * Single source of truth for business contact + trust details.
 * Values marked PLACEHOLDER are waiting on final client-supplied information.
 */
export const business = {
  name: "Electrical Panels Only",
  shortName: "EPO",
  tagline: "It's What We Do",
  legalName: "Electrical Panels Only LLC",
  /** Verified business line. */
  phone: "(720) 665-6943",
  phoneHref: "tel:+17206656943",
  emails: {
    general: "info@electricalpanelsonly.com",
    sales: "sales@electricalpanelsonly.com",
    accounting: "accounting@electricalpanelsonly.com",
  },
  hours: [
    { days: "Monday – Friday", time: "7:00 AM – 5:00 PM" },
    { days: "Saturday", time: "By appointment" },
    { days: "Sunday", time: "Closed" },
  ],
  credentials: {
    /** PLACEHOLDER — CO electrical contractor license number. */
    license: "CO Lic. #TBD",
    /** PLACEHOLDER — general liability policy number. */
    insurance: "Insured — Policy #TBD",
  },
  /**
   * Flip to true once the license and insurance numbers above are the real
   * ones. While false, the site says "Licensed and insured" instead of
   * printing placeholder numbers.
   */
  credentialNumbersAreReal: false,
  yearsExperience: 35,
  financingPartner: "Hearth",
  /** Live Hearth partner prequalification URL (EPO org 65028 / partner 114358). */
  financingUrl: "https://app.gethearth.com/financing/65028/114358/prequalify",
  /** True once financingUrl points at the real Hearth application. */
  financingUrlIsLive: true,

  /**
   * Calendly on-site estimate calendar. Every booking made from the
   * confirmation page lands on Heather's calendar.
   */
  scheduling: {
    provider: "Calendly",
    /** Base event URL — query flags are added by the widget component. */
    url: "https://calendly.com/electricalpanelsonly/on-site-estimate",
  },

  financingNmls: "1628533",
  financingNmlsUrl: "https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1628533",
  /**
   * PLACEHOLDER — paste the live profile URLs. Anything left empty is simply
   * not rendered (no dead links) and is omitted from structured data.
   */
  social: {
    facebook: "",
    instagram: "",
  },
  /**
   * PLACEHOLDER — Google Business Profile.
   * `profileUrl`: the public maps/business listing URL.
   * `reviewUrl`:  the "write a review" short link (g.page/r/...).
   */
  googleBusiness: {
    profileUrl: "",
    reviewUrl: "",
  },
  /**
   * Google measurement IDs. Leaving a value empty switches that tag off
   * sitewide — no script is loaded and nothing is tracked.
   */
  analytics: {
    /** GA4 measurement ID — the reporting property. */
    gtagId: "G-XNEF34ECBM",
    /** Google Tag Manager container — delivery system for future tags. */
    gtmId: "GTM-TKNJS373",
    /** Meta (Facebook) Pixel ID. */
    metaPixelId: "1563260162242279",
  },
  /**
   * Inbox that receives estimate/contact form notifications once email
   * sending is switched on. Quote requests go to the sales inbox.
   */
  leadNotifyEmail: "sales@electricalpanelsonly.com",
} as const;

export const trustPoints = [
  {
    title: "Panel work is our whole trade",
    body: "Residential panels are what our crews build their week around, so whoever opens your cover plate knows what to look for behind it.",
  },
  {
    title: "35 years in Colorado homes",
    body: "Screw-in fuse boxes in Denver bungalows, 1970s panels in Aurora ranches, EV-ready service in new builds.",
  },
  {
    title: "Family-run, with our own crews",
    body: "Everyone on your job is on our payroll, so the person who quotes the work and the crew who installs it are the same team.",
  },
  {
    title: "Permit, utility and inspection handled",
    body: "We pull the permit, book the Xcel disconnect and meet the inspector, with the price agreed before any of it starts.",
  },
] as const;
